<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav class="">
        <h4 class="mb-0">Выплаты зарплаты</h4>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-row>
          <b-col cols="auto">
            <b-dropdown v-if="canEditSalaries()" id="dropdown-create" right size="sm" text="Новое" variant="success">
              <template #button-content>
                <font-awesome-icon :icon="['fas', 'plus']" />
                Новое
              </template>
              <b-dropdown-item-button @click="onCreate(1)">Выплата Аванса</b-dropdown-item-button>
              <b-dropdown-item-button @click="onCreate(2)">Выплата Зарплаты</b-dropdown-item-button>
              <b-dropdown-item-button @click="onCreate(3)">Выплата Отпуска</b-dropdown-item-button>
              <b-dropdown-item-button @click="onCreate(4)">Выплата Премии</b-dropdown-item-button>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item-button @click="onCreate(5)">Выплата Аванса Сдельно</b-dropdown-item-button>
              <b-dropdown-item-button @click="onCreate(6)">Выплата Зарплаты Сдельно</b-dropdown-item-button>
              <b-dropdown-item-button @click="onCreate(7)">Выплата Премии Сдельно</b-dropdown-item-button>
            </b-dropdown>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <b-navbar id="filters">
      <b-navbar-nav>
        <b-form inline @submit.prevent="onSearch()">
          <b-form-input
            class="mb-1 mr-2"
            size="sm"
            v-model="filters.query"
            debounce="500"
            placeholder="Поиск" />

          <month-picker
            class="mb-1 mr-2"
            v-model="filters.period"
            label="Период"
            placeholder="Выберите период"
            :min-year="2025"
            :clearable = true
          />

          <organization-select
            id="input-organization-select"
            ref="organization_select"
            class="mb-1 mr-2"
            v-bind:initial-id="filters.org_id"
            v-on:onSelect="onSelectOrganization"
          />

          <b-button
            class="mb-1 mr-1"
            size="sm"
            variant="outline-success"
            type="submit"
          >
            Применить
          </b-button>
        </b-form>
      </b-navbar-nav>
    </b-navbar>

    <b-table
      id="salaries"
      ref="salaries"
      class="mb-0 text-small"
      selectable
      select-mode="single"
      selectedVariant="success"
      striped
      small
      responsive
      bordered
      show-empty
      :empty-text="$t('message.common.emptyTable')"
      :busy="isBusy"
      :items="items"
      :fields="fields"
      no-provider-filtering
      no-provider-paging
      no-provider-sorting
      @row-dblclicked="onRowClicked"
      sticky-header
      head-variant="light"
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Загрузка</strong>
        </div>
      </template>

      <template #cell(staffs)="row">
        <div class="text-small" v-if="row.item.staffs.length<50">{{ row.item.staffs }}</div>
        <div class="text-small" v-else>{{ row.item.staffs.substring(0, 70) + ".." }}</div>
      </template>

      <template #cell(action)="row">
        <b-btn v-if="canEditSalaries()" size="sm" variant="primary" @click="onEdit(row.item)">
          <font-awesome-icon icon="edit"/>
        </b-btn>
      </template>
    </b-table>

    <pagination-footer
      :total-rows="totalRows"
      :per-page.sync="perPage"
      @page-click="onPagination"
      @per-page-change="onPerPageChange"
    />
  </div>
</template>

<script>
import salaries from "../../network/salaries";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
  import permissions, {PERM} from "../../utilites/permissions";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../utilites/pageSearchService";
    import MonthPicker from "../MonthPicker/MonthPicker";
    import OrganizationSelect from "../Organizations/OrganizationSelect";

export default {
  name: "Salaries",
  components: { PaginationFooter, MonthPicker, OrganizationSelect },
  mixins: [
    salaries,
    helpers, dateFormatter, permissions, pageSearchService
  ],
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'id',
          sortable: false,
          class: 'salary-id'
        },
        {
          key: 'period',
          label: "Период",
          sortable: false,
          class: 'salary-period',
          formatter: 'formatTableMonthPeriod'
        },
        {
          key: 'payment_date',
          label: "Дата",
          class: 'salary-payment-date',
          sortable: false,
          formatter: 'formatTableDate'
        },
        {
          key: 'code',
          label: "Номер",
          sortable: false,
          class: 'salary-code',
        },
        {
          key: 'type_name',
          label: "Тип документа",
          sortable: false,
          class: 'salary-type',
        },
        {
          key: 'salary_type_name',
          label: "Способ выплаты",
          sortable: false,
          class: 'salary-salary-type',
        },
        {
          key: 'organization_name',
          label: "Организация",
          sortable: false,
          class: 'salary-organization-name',
        },
        {
          key: 'amount_sum',
          label: "Выплачено",
          sortable: false,
          class: 'salary-amount-sum',
          formatter: 'priceFormat',
        },
        {
          key: 'ndfl_amount_sum',
          label: "НДФЛ",
          sortable: false,
          class: 'salary-ndfl-amount-sum',
          formatter: 'priceFormat',
        },
        {
          key: 'insurance_amount_sum',
          label: "Страховые",
          sortable: false,
          class: 'salary-insurance-amount-sum',
          formatter: 'priceFormat',
        },
        {
          key: 'pension_before_amount_sum',
          label: "Пенс. до превыш.",
          sortable: false,
          class: 'salary-pension-amount-sum',
          formatter: 'priceFormat',
        },
        {
          key: 'pension_after_amount_sum',
          label: "Пенс. после превыш.",
          sortable: false,
          class: 'salary-pension-amount-sum',
          formatter: 'priceFormat',
        },
        {
          key: 'comment',
          label: "Коментарий",
          sortable: false,
          class: 'salary-comment',
        },
        {
          key: 'staffs',
          label: "Сотрудники",
          sortable: false,
          class: 'salary-staff',
        },
        {
          key: 'action',
          label: "Действия",
          class: 'salary-action'
        },
      ],
      isBusy: false,
      filters: {
        query: '',
        period: null,
        org_id: 0,
      },
      deleteRow: {
        id: null,
        name: ''
      },
    }
  },
  async created() {
    const query = this.$route.query;

    if (query) {
      if (query.query) {
        this.filters.query = query.query;
      }

      if (query.period) {
        this.filters.period = this.dateFromServerString(query.period);
      }

      if (query.org_id) {
        this.filters.org_id = query.org_id;
      }
    }

    if (this.$route.hash) {
      this.currentPage = this.getPage(this.$route.hash);
    }

    await this.getItems();
  },
  async mounted() {
    await this.configureRefs();
  },
  methods: {
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.filters.query,
      }

      if (this.filters.period != null) {
        data.period = this.formatDateOnly(this.filters.period);
      }

      if (this.filters.org_id > 0) {
        data.org_id = this.filters.org_id;
      }

      this.isBusy = true;
      const result = await this.getSalaries(data);
      this.isBusy = false;
      if (result.data == null) {
        this.items = [];
        this.totalRows = 0;
        const mess = "Что-то пошло не так. Попробуйте обновить страницу и повторить действие."
        this.showError(mess);
        return;
      }

      result.data.items.forEach((item, index) => {
        result.data.items[index].staffs = this.mapStaffs(item.salary_staffs);
      })

      this.items = result.data.items;
      this.totalRows = result.data.total;
    },
    onCreate(typeId) {
      if (typeId != null) {
        if (this.hasPermission([PERM.STAFF_EDIT])) {
          this.$router.push({name: 'SalaryAdd', params: { type_id: typeId }}).catch(()=>{});
        }
      }
    },
    onEdit(item) {
      if (this.hasPermission([PERM.STAFF_EDIT])) {
        this.$router.push({name: 'SalaryEdit', params: { id: item.id }}).catch(()=>{});
      }
    },
    async configureRefs() {
      if (this.$refs.organization_select != null) {
        await this.$refs.organization_select.configure(this.filters.org_id);
      }
    },
    onRowClicked(item) {
      this.onEdit(item);
    },
    formatTableMonthPeriod(date) {
      const options = {
        year: "numeric",
        month: "long",
      };
      return this.capitalizeFirstLetter(
        new Date(this.formattedFromServerDate(date))
          .toLocaleDateString("ru-RU", options));
    },
    formattedFromServerDate(date) {
      if (date != null) {
        date = this.formatDate(this.getDateFromServerString(date));
      }
      return date;
    },
    capitalizeFirstLetter(val) {
      return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    },
    mapStaffs(staffs) {
      if (staffs == null) { return ''}
      return staffs.map(obj => obj.staff_name).join(', ');
    },
    onSelectOrganization(id) {
      this.filters.org_id = id;
    },
    // Permissions
    canEditSalaries() {
      return this.hasPermission([PERM.STAFF_EDIT]);
    }
  }
}
</script>

<style>
#salaries td {
  vertical-align: middle;
}

#salaries th {
  vertical-align: middle;
}

.salary-id {
  padding-left: 10px !important;
  padding-right: 10px !important;
  width: 60px;
  min-width: 60px;
  text-align: center;
}

.salary-period {
  min-width: 120px;
  max-width: 120px;
  width: 120px;
}

.salary-payment-date {
  min-width: 100px;
  max-width: 100px;
  width: 100px;
}

.salary-code {
  min-width: 120px;
  max-width: 120px;
  width: 120px;
}

.salary-type {
  min-width: 120px;
  max-width: 120px;
  width: 120px;
}

.salary-salary-type {
  min-width: 120px;
  max-width: 120px;
  width: 120px;
}

.salary-organization-name {
  min-width: 150px;
  max-width: 150px;
  width: 150px;
}

.salary-income-type {
  min-width: 120px;
  max-width: 120px;
  width: 120px;
}

.salary-amount-sum {
  min-width: 100px;
  max-width: 100px;
  width: 100px;
}

.salary-ndfl-amount-sum {
  min-width: 100px;
  max-width: 100px;
  width: 100px;
}

.salary-insurance-amount-sum {
  min-width: 100px;
  max-width: 100px;
  width: 100px;
}

.salary-pension-amount-sum {
  min-width: 100px;
  max-width: 100px;
  width: 100px;
}

.salary-comment {
  min-width: 150px;
  max-width: 150px;
  width: 150px;
}

.salary-staff {
  min-width: 150px;
  max-width: 150px;
  width: 150px;
}

.salary-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Salary/Salaries.vue